export const panoramaCallbackRoutePath = 'panorama/callback';

export const isPanoramaCallbackRoute = (pathname: string): boolean =>
  pathname.endsWith(`/${panoramaCallbackRoutePath}`);

const panoramaCallbackParameterNames = [
  'source',
  'orgCode',
  'orgName',
  'state',
];
const panoramaCallbackSource = 'panorama';

export const getPanoramaCallback = (search: string) => {
  const searchParams = new URLSearchParams(search);

  return {
    hasState: searchParams.has('state'),
    isPanoramaCallback: searchParams.get('source') === panoramaCallbackSource,
    orgCode: searchParams.get('orgCode'),
    orgName: searchParams.get('orgName'),
    state: searchParams.get('state'),
  };
};

export const getPanoramaCallbackHandoffSearch = (search: string): string => {
  const callbackSearchParams = new URLSearchParams(search);
  const handoffSearchParams = new URLSearchParams({
    source: panoramaCallbackSource,
  });
  const state = callbackSearchParams.get('state');

  if (state === null) {
    return `?${handoffSearchParams.toString()}`;
  }

  handoffSearchParams.set('state', state);

  ['orgCode', 'orgName'].forEach((parameterName) => {
    const parameterValue = callbackSearchParams.get(parameterName);

    if (parameterValue !== null) {
      handoffSearchParams.set(parameterName, parameterValue);
    }
  });

  return `?${handoffSearchParams.toString()}`;
};

export const removePanoramaCallbackParameters = (search: string): string => {
  const searchParams = new URLSearchParams(search);

  panoramaCallbackParameterNames.forEach((parameterName) => {
    searchParams.delete(parameterName);
  });

  const remainingParameters = searchParams.toString();

  return remainingParameters ? `?${remainingParameters}` : '';
};
